module.exports = __webpack_public_path__ + "img/3_5_bonus.e7fb2275.png";